document.addEventListener("turbolinks:load", function() {
	if ($('#recommend-settings-wrapper').length) {

		/**
		 * カートシステムプルダウン変更時イベント
		 * カートシステムに応じてプレフィックス項目の有効・無効を切り替える
		 * 各カートの必要プレフィックスは下記の通り
		 * - shopify ... item
		 * - ec-cube ... item & image
		 * - ochanoko-net ... item & image
		 * - feature-shop ... item
		 * - order-made ... item & image
		 * - other ... none
		 */
		function changeCartSystem(){
			let cartSystem = $('#recommend-cart-system-name').val();
			let pcPrefixItem = $('#recommend-item-url-prefix');
			let pcPrefixImage = $('#recommend-image-url-prefix');
			let spPrefixItem = $('#recommend-sp-item-url-prefix');
			let spPrefixImage = $('#recommend-sp-image-url-prefix');
			switch (cartSystem) {
				case 'shopify':
					pcPrefixItem.prop('disabled', false);
					pcPrefixImage.prop('disabled', true);
					spPrefixItem.prop('disabled', false);
					spPrefixImage.prop('disabled', true);
					break;
				case 'ec-cube':
					pcPrefixItem.prop('disabled', false);
					pcPrefixImage.prop('disabled', false);
					spPrefixItem.prop('disabled', false);
					spPrefixImage.prop('disabled', false);
					break;
				case 'ochanoko-net':
					pcPrefixItem.prop('disabled', false);
					pcPrefixImage.prop('disabled', false);
					spPrefixItem.prop('disabled', false);
					spPrefixImage.prop('disabled', false);
					break;
				case 'feature-shop':
					pcPrefixItem.prop('disabled', false);
					pcPrefixImage.prop('disabled', true);
					spPrefixItem.prop('disabled', false);
					spPrefixImage.prop('disabled', true);
					break;
				case 'order-made':
					pcPrefixItem.prop('disabled', false);
					pcPrefixImage.prop('disabled', false);
					spPrefixItem.prop('disabled', false);
					spPrefixImage.prop('disabled', false);
					break;
				default:
					pcPrefixItem.prop('disabled', true);
					pcPrefixImage.prop('disabled', true);
					spPrefixItem.prop('disabled', true);
					spPrefixImage.prop('disabled', true);
					break;
			}
		}
		$('#recommend-cart-system-name').on('change', function(){
			console.log('change');
			changeCartSystem();
		});
		changeCartSystem();


		// csvファイル設置URLの登録イベント
		$('#update-recommend-csv-url').on('click', function(){
			let itemUrl = $('#recommend-item-csv-url').val();
			let activityUrl = $('#recommend-activity-csv-url').val();
			let cartSystemName = $('#recommend-cart-system-name').val();
			let ftpHost = $('#recommend-ftp-host').val();
			let ftpUser = $('#recommend-ftp-user').val();
			let ftpPassword = $('#recommend-ftp-password').val();
			let ftpFilePath = $('#recommend-ftp-file-path').val();
			let itemUrlPrefix = $('#recommend-item-url-prefix').val();
			let imageUrlPrefix = $('#recommend-image-url-prefix').val();
			let spItemUrlPrefix = $('#recommend-sp-item-url-prefix').val();
			let spImageUrlPrefix = $('#recommend-sp-image-url-prefix').val();
			// if (itemUrl === "" || itemUrl.trim() === "") {
			// 	alert('URLが入力されていません');
			// 	return;
			// }
			// if (activityUrl === "" || activityUrl.trim() === "") {
			// 	alert('URLが入力されていません');
			// 	return;
			// }
			$.ajax({
				url: "/recommend_settings/update_csv_url",
				type: 'post',
				dataType: 'json',
				data: {
					item_csv_url: itemUrl,
					activity_csv_url: activityUrl,
					cart_system_name: cartSystemName,
					ftp_host: ftpHost,
					ftp_user: ftpUser,
					ftp_password: ftpPassword,
					ftp_file_path: ftpFilePath,
					item_url_prefix: itemUrlPrefix,
					image_url_prefix: imageUrlPrefix,
					sp_item_url_prefix: spItemUrlPrefix,
					sp_image_url_prefix: spImageUrlPrefix,
				},
			})
			.done(function(data){
				if (data['result'] === 'success'){
					alert('登録しました');
					location.reload();
				}else{
					alert(data['message']);
				}
			})
			.fail(function(data){
				alert('登録に失敗しました');
			});
		});

		// URL行の追加ボタンイベント設定
		$('.url-add').on('click', function(){
			let table = $(this).parent('div').first().find('table')
			let tr = table.find('tr:last').clone();
			tr.find('input').val('');
			if (tr.find('.url-del').length) {
				tr.find('.url-del').removeClass('hidden');
			}else{
				let td = $(`<td class="h-50px py-0 px-6 text-left "><div class="url-del btn btn-outline btn-error btn-sm">削除</div></td>`);
				tr.append(td);
			}
			table.append(tr);
			resetInputRemove();
		});

		// URL行の削除ボタンイベント再設定
		function resetInputRemove(){
			$('.url-del').off().on('click', function(){
				$(this).closest('tr').remove();
			});
		}
		resetInputRemove();

		/**
		 * URLの登録ボタンイベント
		 * クリックされたボタンのid名に応じて登録するURLの種類を判定し、対象のtableからURLを取得してPOSTする
		 */
		$('#update-item-page-url, #update-thanks-page-url, #update-excluded-item-page-url, #update-purchase-page-url').on('click', function(){
			let device = $('#device').val();
			let urlType = "";
			let isExcluded = 0;
			switch ($(this).attr('id')) {
				case 'update-item-page-url':
					urlType = "item";
					break;
				case	'update-excluded-item-page-url':
					urlType = "item";
					isExcluded = 1;
					break;
				case 'update-thanks-page-url':
					urlType = "thanks";
					break;
				case 'update-purchase-page-url':
					urlType = "purchase";
					break;
			}
			let targetTable = $(this).parent('div').first().find('table');
			let urls = [];
			targetTable.find('input').each(function(){
				if (this.value === "" || this.value.trim() === "") {
					return true;
				}
				urls.push({['url']: this.value});
			});
			// if (urls.length === 0) {
			// 	alert('URLが入力されていません');
			// 	return;
			// }
			$.ajax({
				url: "/recommend_settings/update_urls",
				type: 'post',
				dataType: 'json',
				data: {
					device: device,
					urls: urls,
					url_type: urlType,
					is_excluded: isExcluded,
				},
			})
			.done(function(data){
				if (data['result'] === 'success'){
					alert('登録しました');
					location.reload();
				}else{
					alert(data['message']);
				}
			})
			.fail(function(data){
				alert('登録に失敗しました');
			});
		});


		// セレクタの設定イベント
		$('#update-cart-in-selector, #update-purchase-confirmed-selector, #update-product-count-selector, #update-item-list-selector').on('click', function(){
			let device = $('#device').val();
			let selectorType = "";
			switch ($(this).attr('id')) {
				case 'update-cart-in-selector':
					selectorType = "add_to_cart";
					break;
				case 'update-purchase-confirmed-selector':
					selectorType = "purchase_confirmed";
					break;
				case 'update-item-list-selector':
					selectorType = "item_list";
					break;
				case 'update-product-count-selector':
					selectorType = "product_count";
					break;
			}
			let targetTable = $(this).parent('div').first().find('table');
			let selectors = [];
			targetTable.find('input').each(function(){
				if (this.value === "" || this.value.trim() === "") {
					return true;
				}
				selectors.push({['selector']: this.value});
			});
			
			$.ajax({
				url: "/recommend_settings/update_selectors",
				type: 'post',
				dataType: 'json',
				data: {
					device: device,
					selectors: selectors,
					selector_type: selectorType,
				},
			})
			.done(function(data){
				if (data['result'] === 'success'){
					alert('登録しました');
					location.reload();
				}else{
					alert(data['message']);
				}
			})
			.fail(function(data){
				alert('登録に失敗しました');
			});
		});
	}
});
